// extracted by mini-css-extract-plugin
export default {"dropzone":"ProfilePic_dropzone__eq07S","iconContainer":"ProfilePic_iconContainer__qT9-X","selectedImage":"ProfilePic_selectedImage__d6mu2"};